module.exports = __webpack_public_path__ + "static/media/sharedark.094f5619.svg";